import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as html2canvas from "html2canvas";
import {
  NbWindowService,
  NbWindowState,
  NbDialogService,
} from "@nebular/theme";
import { Router } from "@angular/router";
import { ConfirmDialogComponent } from "../../../utils/confirm-dialog/confirm-dialog.component";
import { CampaignFinance } from "../../../../@core/data/campaignFinance";
import { CampaignFinanceService } from "../../../../@core/api/campaignFinance.service";

@Component({
  selector: "ngx-finance-campaign-row",
  templateUrl: "./finance-campaign-row.component.html",
  styleUrls: ["./finance-campaign-row.component.scss"],
})
export class FinanceCampaignRowComponent implements OnInit {
  @Input() campaign: CampaignFinance;
  @Output() updateList = new EventEmitter();

  constructor(
    private router: Router,
    private dialogService: NbDialogService,
    private campaignService: CampaignFinanceService
  ) {}

  async ngOnInit() {}

  show(type) {
    switch (type) {
      case "edit":
        this.router.navigate(["home", "finance-campaign", this.campaign.id]);
        break;
      case "copy":
        this.copyCampaignFinance();
        break;

        case "statistics":
          this.router.navigate(["home", "finance-statistics", this.campaign.id]);
          break;


      case "export":
        this.router.navigate(["home", "finance-export", this.campaign.id]);
        break;

      case "delete":
        this.dialogService
          .open(ConfirmDialogComponent, {
            context: { operation: "eliminare " + this.campaign.name },
          })
          .onClose.subscribe((res) => {
            if (res) {
              this.DeleteCampaignFinance();
            }
          });
        break;
    }
  }

  async copyCampaignFinance() {
    let campaign = this.campaign;
    campaign.name = campaign.name + " (Copia)";
    let res = <any>await this.campaignService.createCampaignFinance(campaign);
    this.updateList.emit();
  }

  async toggleCampaignFinance() {
    let campaign = this.campaign;
    campaign.pause = !campaign.pause;
    let res = <any>(
      await this.campaignService.editCampaignFinance(campaign, campaign.id)
    );
    this.updateList.emit();
  }

  async DeleteCampaignFinance() {
    await this.campaignService.deleteCampaignFinance(this.campaign.id);
    this.updateList.emit();
  }
}
